import React from "react";
import Icon from "@ant-design/icons";
const CollegeSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		{/* <g clip-path="url(#clip0_1607_88173)"> */}
		<g clipPath="url(#clip0_1607_88173)">
			<path
				d="M2.66634 3.99772L7.99967 1.33105L13.333 3.99772M11.9997 6.66439L14.6663 7.99772V13.3311C14.6663 13.6847 14.5259 14.0238 14.2758 14.2739C14.0258 14.5239 13.6866 14.6644 13.333 14.6644H2.66634C2.31272 14.6644 1.97358 14.5239 1.72353 14.2739C1.47348 14.0238 1.33301 13.6847 1.33301 13.3311V7.99772L3.99967 6.66439"
				stroke="#9E9E9E"
				// stroke-width="1.35802"
				// stroke-linecap="round"
				// stroke-linejoin="round"
				strokeWidth="1.35802"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.33285 14.6624V11.9958C9.33285 11.6421 9.19237 11.303 8.94232 11.053C8.69227 10.8029 8.35313 10.6624 7.99951 10.6624C7.64589 10.6624 7.30675 10.8029 7.0567 11.053C6.80665 11.303 6.66618 11.6421 6.66618 11.9958V14.6624M11.9995 3.3291V14.6624M3.99951 3.3291V14.6624"
				stroke="#9E9E9E"
				// stroke-width="1.35802"
				// stroke-linecap="round"
				// stroke-linejoin="round"
				strokeWidth="1.35802"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.99935 7.33171C8.73573 7.33171 9.33268 6.73475 9.33268 5.99837C9.33268 5.26199 8.73573 4.66504 7.99935 4.66504C7.26297 4.66504 6.66602 5.26199 6.66602 5.99837C6.66602 6.73475 7.26297 7.33171 7.99935 7.33171Z"
				stroke="#9E9E9E"
				// stroke-width="1.35802"
				// stroke-linecap="round"
				// stroke-linejoin="round"
				strokeWidth="1.35802"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1607_88173">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const CollegeIcon = (props) => (
	<Icon component={() => <CollegeSvg {...props} />} />
);

export default CollegeIcon;
